module.exports = __webpack_public_path__ + "img/completed.14b8985f.svg";